// src/components/common/AdBanner.js
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background-color: rgba(255, 255, 255, 0.9);
  border-top: 1px solid #e0e0e0;
  z-index: 1000; /* Ridotto da 1800 */
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  
  @media (max-width: 768px) {
    height: 60px;
  }
`;


const AdContainer = styled.div`
  width: 100%;
  max-width: 728px;
  height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const AdBanner = ({ isVisible = true }) => {
  const adRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);
  const adLoadedRef = useRef(false);

  useEffect(() => {
    if (isVisible) {
      // Aspetta che la pagina sia completamente caricata
      const timer = setTimeout(() => {
        setShouldLoad(true);
      }, 2000); // 2 secondi di delay

      return () => clearTimeout(timer);
    }
  }, [isVisible]);

  useEffect(() => {
    if (shouldLoad && !adLoadedRef.current) {
      const loadAd = () => {
        try {
          if (window.adsbygoogle && adRef.current) {
            // Controllo aggiuntivo per le dimensioni
            const container = adRef.current.parentElement;
            if (container && container.offsetWidth > 0) {
              (window.adsbygoogle = window.adsbygoogle || []).push({});
              adLoadedRef.current = true;
            } else {
              setTimeout(loadAd, 1000);
            }
          } else {
            setTimeout(loadAd, 1000);
          }
        } catch (error) {
          console.warn('AdSense non disponibile:', error.message);
          // Non mostrare errori all'utente
        }
      };
      
      loadAd();
    }
  }, [shouldLoad]);

  if (!isVisible || !shouldLoad) return null;
  
  return (
    <BannerContainer>
      <AdContainer>
        <ins
          ref={adRef}
          className="adsbygoogle"
          style={{ 
            display: 'block',
            width: '100%',
            height: '100%',
            minWidth: '300px',
            minHeight: '50px'
          }}
          data-ad-client="ca-pub-3310925003480726"
          data-ad-slot="3190683197" 
          data-ad-format="auto"
          data-full-width-responsive="true"
        />
      </AdContainer>
    </BannerContainer>
  );
};

export default AdBanner;
